/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Terms_Warningmessage1Inputs */

const en_welcome_terms_warningmessage1 = /** @type {(inputs: Welcome_Terms_Warningmessage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To continue to your account, you need to accept our Terms and Conditions. If you choose to decline, you will be logged out immediately and unable to access your account until you accept the terms.`)
};

/**
* | output |
* | --- |
* | "To continue to your account, you need to accept our Terms and Conditions. If you choose to decline, you will be logged out immediately and unable to access y..." |
*
* @param {Welcome_Terms_Warningmessage1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const welcome_terms_warningmessage1 = /** @type {((inputs?: Welcome_Terms_Warningmessage1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Terms_Warningmessage1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_welcome_terms_warningmessage1(inputs)
});
export { welcome_terms_warningmessage1 as "welcome_terms_warningMessage" }